import { useEffect } from "react";

const mainTitle = process.env.REACT_APP_NODE_ENV === 'test' ? "SynergyTop" : "Machadalo";
function useLocalStorageLeadTitleUpdater() {
  useEffect(() => {
    const updateTitle = () => {
      try {
        const raw = localStorage.getItem("notifications");
        const storedData =
          raw ? JSON.parse(raw) : { notification: { leads: {} } };
        const leads = storedData.notification?.leads || {};

        // Calculate total number of leads across all form IDs
        const totalLeads = Object.values(leads).reduce<number>(
          (count: number, arr: unknown) => count + (Array.isArray(arr) ? (arr as unknown[]).length : 0),
          0
        );

        // Update document title
        document.title =
          totalLeads > 0 ? `(${totalLeads}) New Leads | ${mainTitle}` : mainTitle;
      } catch (error) {
        console.error("Error updating document title:", error);
      }
    };

    // Run immediately on mount
    updateTitle();

    // Listen for updates from same tab (custom event)
    const handleCustomUpdate = () => updateTitle();
    window.addEventListener("notifications-updated", handleCustomUpdate);

    // Listen for updates from other tabs
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "notifications") updateTitle();
    };
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("notifications-updated", handleCustomUpdate);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
}

export default useLocalStorageLeadTitleUpdater;
